module.exports = __webpack_public_path__ + "img/fa-v2-regular-400.11d3abbe.svg";